export const MicroAppContainer = {
  MAIN_CONTENT: '#appContainer',
  NAVIGATOR_MENU: '#navigatorMenu',
}

export const PATH_SEPARATOR = '/'

export const DEFAULT_SITE_BASE = '/'

const ACCESS_TOKEN_EXPIRED_THRESHOLD_IN_MS = 30 * 1000

export const TimeConstants = {
  FASTER_DEBOUNCING_IN_MS: 300,
  DEFAULT_DEBOUNCING_IN_MS: 500,
  DEFAULT_THROTTLING_IN_MS: 200,
  DEFAULT_RETRY_TIMEOUT_FACTOR: 1.5,
  DEFAULT_RETRY_TIMES: 3,
  ACCESS_TOKEN_EXPIRED_THRESHOLD_IN_MS,
  USER_INTERACTIVE_EVENT_THROTTLING_IN_MS: 4 * 1000,
}

export const Router = {
  MAIN_APP: 'main',
  MICRO_APP_MAIN: 'mapp',
  MICRO_APP_PREVIEW_BASE: 'preview',
  ROUTE_NAME_MAIN_APP_HOME: 'IndexPage',
  ROUTE_NAME_MICRO_APP_MAIN: 'IndexMappPage',
  ROUTE_NAME_MICRO_APP_PREVIEW: 'PreviewWindow',
}

export const LoginStatus = {
  TIME_OUT: 'timeout',
  LOGIN_IS_SUCCESS: 'success',
}

export enum BrandName {
  HEYTAP = 'heytap',
  OPPO = 'oppo',
  REALME = 'realme',
}

export const BrandNameMap = new Map<string, BrandName>([
  ['heytap.com', BrandName.HEYTAP],
  ['oppo.com', BrandName.OPPO],
  ['realme.com', BrandName.REALME],
])

export const BrandDomainMap = {
  [BrandName.HEYTAP]: 'heytap',
  [BrandName.OPPO]: 'oppo',
  [BrandName.REALME]: 'realme',
}

export interface BrandField {
  OSField: string
  brand: string
  policySubject: string
  registeredAddress: string
  postCode: string
  baseDomain: string
  OSVersion: string
  applicationVersion: string
}

export const BrandFieldMap = new Map<BrandName, BrandField>([
  [
    BrandName.OPPO,
    {
      OSField: 'ColorOS',
      brand: 'OPPO',
      policySubject: 'OPPO广东移动通信有限公司及其关联公司',
      registeredAddress: '广东省东莞市长安镇乌沙海滨路18号',
      postCode: '523902',
      baseDomain: 'oppo.com',
      OSVersion: '13.1',
      applicationVersion: '15.0.0',
    },
  ],
  [
    BrandName.HEYTAP,
    {
      OSField: 'ColorOS',
      brand: 'OPPO',
      policySubject: 'OPPO广东移动通信有限公司及其关联公司',
      registeredAddress: '广东省东莞市长安镇乌沙海滨路18号',
      postCode: '523902',
      baseDomain: 'oppo.com',
      OSVersion: '13.1',
      applicationVersion: '15.0.0',
    },
  ],
  [
    BrandName.REALME,
    {
      OSField: 'realme UI',
      brand: '真我',
      policySubject: 'RealMe重庆移动通信有限公司及其关联公司',
      registeredAddress: '重庆市渝北区玉峰山镇玉龙大道178号',
      postCode: '401100',
      baseDomain: 'realme.com',
      OSVersion: '4.0',
      applicationVersion: '15.0.0',
    },
  ],
])
